import { render, staticRenderFns } from "./PickingModeConfig.vue?vue&type=template&id=226774ac"
import script from "./PickingModeConfig.vue?vue&type=script&lang=js"
export * from "./PickingModeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports